$(function() {
	var lazyLoadImg = new LazyLoad({
	    elements_selector: "img[data-src]",
	});
	var lazyLoadBg = new LazyLoad({
	    elements_selector: "[data-bg]",
	});
});